import { render } from "./ViewSubmissionModal.vue?vue&type=template&id=f97f7f30&scoped=true"
import script from "./ViewSubmissionModal.vue?vue&type=script&lang=ts"
export * from "./ViewSubmissionModal.vue?vue&type=script&lang=ts"

import "./ViewSubmissionModal.vue?vue&type=style&index=0&id=f97f7f30&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-f97f7f30"

export default script